import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

const ContinueDialog = ({ isOpen, handleClose }) => {
	return (
		<Dialog open={isOpen} fullWidth={true} maxWidth={'sm'} onClose={handleClose}>
			<DialogTitle>
				<Typography component={'span'} variant={'h4'} color={'primary'}>
					Thank you for signing up!
				</Typography>
			</DialogTitle>
			<DialogContent>
				<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
					<Typography component={'span'} sx={{ marginBottom: '8px' }}>
						Closing this window or clicking the button below will re-direct you to your MemberCenter page.
					</Typography>
					<Button onClick={handleClose} fullWidth={true} color={'primary'} variant={'contained'}>
						Continue to MemberCenter
					</Button>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default ContinueDialog;
